import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

class AvatarController {
  constructor($log, $window) {
    'ngInject';
    this.log = $log;
    this.window = $window;
  }

  $onInit() {
    const name = this.name;
    const email = this.email;
    const userId = this.userId;
    this.log.log('Avatar', { name }, { email }, { userId });

    if (this.hasName()) {
      const { nameFirstLetter, lastNameFirstLetter } = this.initFirstLetters(this.name);
      this.nameFirstLetter = nameFirstLetter;
      this.lastNameFirstLetter = lastNameFirstLetter;
    }
  }

  hasName() {
    return !isUndefinedOrNullOrEmpty(this.name);
  }

  hasEmail() {
    return !isUndefinedOrNullOrEmpty(this.email);
  }

  hasUserId() {
    return !isUndefinedOrNullOrEmpty(this.userId);
  }

  hasBbvaUId() {
    return !isUndefinedOrNullOrEmpty(this.bbvaUId);
  }

  initFirstLetters(name) {
    name = this.cleanSpaces(name);
    const namesplit = name.split(' ');
    const nameFirstLetter = namesplit[0].substring(0, 1).toUpperCase();
    const lastNameFirstLetter = namesplit[1].substring(0, 1).toUpperCase();
    return { nameFirstLetter, lastNameFirstLetter };
  }

  cleanSpaces(string) {
    return string.replace(/ +(?= )/g, '');
  }

  getContainerCss() {
    return {
      'size-big': angular.isDefined(this.sizeBig),
      'size-medium': angular.isDefined(this.mediumSize),
      'with-picture': this.source
    };
  }
}

export default AvatarController;



// WEBPACK FOOTER //
// ./client/app/components/avatar/avatar.controller.js